import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import { useAppDispatch } from '../../../../../store/hooks';
import { ReactComponent as CheckmarkIcon } from '../../../../shared/assets/icons/snackbar-icons/check-mark.svg';
import { ReactComponent as WarningIcon } from '../../../../shared/assets/icons/snackbar-icons/warning.svg';
import { SnackBarContext } from '../../../../shared/components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { useSnackbarContextState } from '../../../../shared/hooks/use-snack-bar-context-state/use-snackbar-context-state.hook';
import { WebGameRequestModel } from '../../../models/web-game-request.model';
import { resetGameForm } from '../../../store/slices/web-game.slice';
import { createWebGame } from '../../../thunks/create-web-game.thunk';
import { WebGameFormikModel } from '../models/web-game-formik.model';

export const useHandleGameSubmit = (
  isOnEdit: boolean,
  thumbnailFileId: number | null,
  zipFileId: number | null,
  id?: string
): ((values: WebGameFormikModel) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const snackbarCtx = useContext(SnackBarContext) as SnackBarContextModel;
  const snackBarConfig = useSnackbarContextState();
  const successSnackBarConfig = () => {
    snackBarConfig(
      'success',
      `Successfully ${isOnEdit && id ? 'updated' : 'created'} the game !`,
      <CheckmarkIcon />
    );
  };

  const errorSnackBarConfig = (errorMsg: string) => {
    snackBarConfig('error', errorMsg, <WarningIcon />);
  };

  return async (values: WebGameFormikModel) => {
    const gameBody: WebGameRequestModel = {
      zipFileId: zipFileId as number,
      thumbnailFileId: thumbnailFileId as number,
      genre: values.genre,
      size: values.size,
      title: values.title,
      orientation: values.orientation,
    };

    try {
      await dispatch(
        createWebGame(isOnEdit && id ? { ...gameBody, id: +id } : gameBody)
      ).unwrap();
      dispatch(resetGameForm());
      successSnackBarConfig();
      navigate('../../game-center-management');
    } catch (err) {
      let errorMsg =
        'Something went wrong! Please check again the information.';
      if (axios.isAxiosError(err)) {
        errorMsg = err.message;
      }
      errorSnackBarConfig(errorMsg);
    } finally {
      snackbarCtx.isOpen(true);
    }
  };
};
